import { Badge, Box } from "@radix-ui/themes";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

type Props = {
  name: string;
  picture: string;
  type?: "style" | "model" | "pack";
  subtype?: "avatar" | "animal" | "object" | "car" | "style";
  ratio?: "square" | "landscape" | "portrait";
  pending?: boolean;
  public?: boolean;
  className?: string;
};

export const LoraTile = (props: Props) => {
  const { t } = useTranslation();

  const picture = props.picture;
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = picture;
    img.onload = () => setLoaded(true);
  }, [picture]);

  return (
    <Box
      className={twMerge(
        "rounded-md cursor-pointer transition-opacity duration-200 hover:opacity-85",
        "shrink-0 inline-flex flex-col overflow-hidden h-32 w-32 md:h-40 md:w-40 transition-all duration-200",
        props.pending && "animate-pulse",
        props.type !== "model" && "h-20 md:h-24",
        loaded ? "opacity-100" : "opacity-0",
        props.className
      )}
      style={
        picture
          ? {
              backgroundImage: "url('" + picture + "')",
              backgroundPosition:
                props.type !== "model" ? "center 30%" : "center",
              backgroundSize: "cover",
            }
          : {}
      }
    >
      <div
        className={twMerge(
          "p-1 pt-0.5 space-y-1 grow flex flex-col h-full",
          props.pending && "backdrop-blur-sm"
        )}
      >
        <div className={"space-x-1"}>
          {props.type === "style" && (
            <Badge variant="surface" color="gray">
              Style
            </Badge>
          )}
          {props.type === "pack" && (
            <Badge variant="surface" color="amber">
              Pack
            </Badge>
          )}
          {props.subtype === "avatar" && (
            <Badge variant="surface" color="blue">
              Avatar
            </Badge>
          )}
          {props.subtype === "animal" && (
            <Badge variant="surface" color="green">
              Animal
            </Badge>
          )}
          {props.subtype === "car" && (
            <Badge variant="surface" color="green">
              Car
            </Badge>
          )}
          {props.subtype === "object" && (
            <Badge variant="surface" color="purple">
              Objet
            </Badge>
          )}
          {props.pending && (
            <Badge variant="surface" color="yellow">
              En cours
            </Badge>
          )}
          {props.public && (
            <Badge variant="surface" color="indigo">
              Public
            </Badge>
          )}
        </div>
        <div className="grow" />
        <div>
          <Badge variant="solid" color="bronze" size="1">
            {t("packs." + props.name + ".name", props.name)}
          </Badge>
        </div>
      </div>
    </Box>
  );
};
